<template>
  <div class="top_back" v-if="$route.meta.navShow">
    <div class="top_back_arrow" @click="topback">
      <img src="/static/imgs/back.svg" class="top_back_img"/>
    </div>
    <div class="top_back_title">
      {{$route.meta.title}}
    </div>
  </div>
</template>

<script>
  export default {
    name: "topback",
    data() {
      return {

      }
    },
    mounted(){

    },
    methods: {
      topback(){
        if(this.$route.meta.navPath){
          this.$router.replace(this.$route.meta.navPath);
        }else{
          this.$router.back();
        }
      }
    }
  }
</script>

<style scoped>
  .top_back {
    position:fixed;
    top:0;
    left: 0;
    width:100%;
    height:6vh;
    line-height:6vh;
    text-align:center;
    font-weight:bold;
    z-index:99;
    margin:0;
    padding:0;
    background-color:white;
    border-bottom:1px solid #eee;
  }
  .top_back_arrow {
    height:6vh;
    line-height:5vh;
    font-size:1.6rem;
    color: grey;
    width:10%;
    float:left;
  }
  .top_back_title {
    width:80%;
    margin-right:10%;
    float:left;
    text-align:center;
  }
  .top_back_img {
    height:.85rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/topback.vue